import * as httpProtocol from './httpProtocol';
import { logError } from '@shared/utils/httpClientUtil';
import { getAppConfig } from '@shared/services/init/appConfig';
import { Constants } from '@shared/utils/constants';
const option = {
    requireCorrelationId: true,
    stringifyPostData: false,
    authenticationType: httpProtocol.AuthenticationTypes.Spza
};
export function post(authMethod, authKey, review) {
    const endpoint = '/api/userreview';
    if (authMethod === 'accessKey') {
        option.authenticationType = httpProtocol.AuthenticationTypes.Unauthenticated;
    } else {
        option.authenticationType = httpProtocol.AuthenticationTypes.Spza;
    }
    const post = httpProtocol.post(endpoint, option);
    if (option.authenticationType === httpProtocol.AuthenticationTypes.Unauthenticated) {
        post.setHeader(authMethod, authKey);
    }
    return post.setData(review).request().catch((error)=>{
        logError('reviewRestClient.post', error);
        return Promise.reject(error);
    });
}
export function get(authMethod, authKey, appId) {
    if (!appId || appId === '*') {
        appId = '';
    }
    const endpoint = '/api/userreview/' + appId;
    if (authMethod === 'accessKey') {
        option.authenticationType = httpProtocol.AuthenticationTypes.Unauthenticated;
    } else {
        option.authenticationType = httpProtocol.AuthenticationTypes.Spza;
    }
    const get = httpProtocol.get(endpoint, option);
    if (option.authenticationType === httpProtocol.AuthenticationTypes.Unauthenticated) {
        get.setHeader(authMethod, authKey);
    }
    return get.request().catch((error)=>{
        logError('reviewRestClient.get', error);
        return Promise.reject(error);
    });
}
export function del(authMethod, authKey, appId, review) {
    const endpoint = '/api/userreview/' + appId;
    if (!appId) {
        logError('reviewRestClient.del', 'missing appId');
        return null;
    }
    if (authMethod === 'accessKey') {
        option.authenticationType = httpProtocol.AuthenticationTypes.Unauthenticated;
    } else {
        option.authenticationType = httpProtocol.AuthenticationTypes.Spza;
    }
    const del = httpProtocol.del(endpoint, option);
    del.option.parseResult = false;
    if (option.authenticationType === httpProtocol.AuthenticationTypes.Unauthenticated) {
        del.setHeader(authMethod, authKey);
    }
    return del.setData(review).request().catch((error)=>{
        logError('reviewRestClient.del', error);
        return Promise.reject(error);
    });
}
export function getPurchaseStatus(appId) {
    if (!appId) {
        return Promise.reject(new Error('AppId is required. Operation: reviewRestClient.getPurchaseStatus'));
    }
    const endpoint = '/view/app/' + appId + '/purchase';
    option.authenticationType = httpProtocol.AuthenticationTypes.Spza;
    const get = httpProtocol.get(endpoint, option);
    get.addQueryEntry(Constants.QueryStrings.ApplicationId, appId);
    return get.addQueryEntry(Constants.QueryStrings.version, getAppConfig(Constants.apiVersion)).request().catch((error)=>{
        logError('reviewRestClient.getPurchaseStatus', error);
        return Promise.resolve(false);
    });
}
